<template lang="pug">
div
  navbar(back="collection-list")
  div.row
    .offset-md-2.col-md-8.offset-sm-1.col-sm-10.q-gutter-md
      q-inner-loading(:showing="itemsLoading")
        .text-h6.q-mb-md Načítám předměty&hellip;
        q-spinner-cube(size="100px" color="primary")
      oarepo-quasar-collection.q-my-md(:collection-code='collectionCode', @item-selected='itemSelected',
        :item-components="itemComponents" :omit-list="true")
        template(v-slot:content-before="{items}")
          q-banner.shadow-2.bg-grey-3.q-pa-lg(inline-actions v-if="items.length === 0")
            template(v-slot:avatar)
              q-icon.q-ma-md.justify-center(color="primary" name="photo_size_select_small")
              span.text-italic.text-weight-light Nebyly nalezeny žádné restaurované předměty
            template(v-slot:action)
              q-btn.q-pa-md(icon='note_add' @click='createNewObject' outline color="secondary") Přidat restaurovaný předmět
        template(v-slot:facets-before="{aggregations}")
          .q-mt-sm.q-mb-lg.q-gutter-sm
            q-btn(icon='note_add' @click='createNewObject' outline color="secondary") Přidat restaurovaný předmět
            q-expansion-item.q-mt-md.shadow-1(outline
            label="Období vzniku"
              icon="cake"
              v-if="aggregations && aggregations['creationPeriod.since'] !== undefined")
              <!-- TODO: Implement proper model update-->
              q-card
                q-card-section.q-pa-lg
                  q-range.col.q-mt-md.q-mr-sm(label dense label-always @change="periodSelected"
                    :value="creationPeriodActualValue(aggregations)"
                    :min="creationPeriodSince(aggregations)"
                    :max="creationPeriodUntil(aggregations)")
                  q-list
                    q-item.q-pa-none.q-ma-none
                      q-checkbox.q-mt-sm(size="small" :value="selectedPeriodActualValue.min === null" @input="periodSelected({min:null, max:null}, $event)") Všechna období
                    q-item.q-pa-none.q-ma-none(v-for="tax in $taxonomies.periodTaxonomy" :key="tax.code")
                      q-checkbox.q-mt-sm(size="small"
                                         :value="selectedPeriodActualValue.min === tax.startYear"
                                         @input="periodSelected({min:tax.startYear, max:tax.endYear}, $event)")
                        div {{ tax.title[0].value }}
                        div.text-grey-8.text-caption.year-value
                          span {{ tax.startYear }} &mdash;&nbsp;
                          span(v-if="tax.endYear") {{ tax.endYear }}

</template>

<script>
import { mixins } from 'vue-class-component'
import { Component } from 'vue-property-decorator'
import { NewObjectMixin } from './editor/new-object-mixin'
import Navbar from '../../components/Navbar'
import { Query } from '@oarepo/invenio-oarepo-ui-vue'

export default @Component({
  props: {
    collectionCode: String
  },
  components: {
    'navbar': Navbar
  }
})
class RestorationsListPage extends mixins(NewObjectMixin) {
  periodRange = {
    min: 0,
    max: 1
  }

  get itemsLoading () {
    return this.oarepo$.collectionModule.state !== 2
  }

  periodSelected (value, checkboxState) {
    if (value.min === null || checkboxState === false) {
      this.periodRange = {
        min: 0,
        max: 1
      }
      const q = new Query(this.$router.currentRoute.query)
      q.removeKey('creationPeriod')
      this.$router.push({
        query: q.query
      })

      this.oarepo$.collectionModule.facetDeselected(
        {
          facet: 'creationPeriod',
          key: `${this.periodRange.min}--${this.periodRange.max}`,
          replace: true
        }
      )
    } else {
      this.periodRange = value
      this.oarepo$.collectionModule.facetSelected(
        {
          facet: 'creationPeriod',
          key: `${this.periodRange.min}--${this.periodRange.max}`,
          replace: true
        }
      )
    }
  }

  creationPeriodActualValue (aggregations) {
    const actual = this.selectedPeriodActualValue
    if (actual.min !== null) {
      return actual
    }
    return {
      min: this.creationPeriodSince(aggregations),
      max: this.creationPeriodUntil(aggregations)
    }
  }

  get selectedPeriodActualValue () {
    const q = new Query(this.$route.query)
    const selectedCreationPeriod = q.get('creationPeriod')
    if (selectedCreationPeriod.length) {
      const selectedCreationPeriodValues = selectedCreationPeriod[0].split('--')
      if (selectedCreationPeriodValues.length === 2) {
        return {
          min: selectedCreationPeriodValues[0],
          max: selectedCreationPeriodValues[1]
        }
      }
    }
    return {
      min: null,
      max: null
    }
  }

  creationPeriodSince (aggregations) {
    return aggregations['creationPeriod.since'] ? aggregations['creationPeriod.since'].value : -100000
  }

  creationPeriodUntil (aggregations) {
    return aggregations['creationPeriod.until'] ? aggregations['creationPeriod.until'].value : (1900 + (new Date()).getYear())
  }

  itemSelected ({ id }) {
    this.$router.push({
      name: 'collectionItem',
      params: {
        collectionCode: this.collectionCode,
        itemId: id
      }
    })
  }

  get itemComponents () {
    return {
      'https://restaurovani.vscht.cz/schemas/krokd/restoration-object-v1.0.0.json': () => import('./RestorationsListItem.vue'),
      'https://restaurovani.vscht.cz/schemas/draft/krokd/restoration-object-v1.0.0.json': () => import('./RestorationsListItem.vue')
      // nothing here
    }
  }

  mounted () {
    if (this.$route.name === 'collection-create') {
      this.createNewObject()
    }
    this.$ui.setBackgroundUrl(null)
  }
}
</script>
<style scoped lang="stylus">
.year-value
  line-height 100%
</style>
